import React from 'react';
import Typography from '@johnlewispartnership/wtr-ingredients/foundations/typography/index.js';
import { buildElementStyling } from '../utils';
import { RichTextNode } from '../types';

const RichTextH4 = ({ children, value }: RichTextNode) => {
  const { className, style } = buildElementStyling({ baseClass: 'richTextH3', value });
  return (
    <Typography element="h4" className={className} style={style}>
      {children}
    </Typography>
  );
};

RichTextH4.displayName = 'RichTextH4';

export default RichTextH4;
